/*
 * Send messages to the parent window
 */
export function sendEvent(event: {
  name: string
  payload: object | string | number | boolean
  meta: object
}) {
  if (typeof window !== "undefined") {
    window.parent.postMessage(event, "*")
  }
}
